// React
import React, { useState } from "react";
// React
// CSS
import styles from "./DataAndInputContainer.module.css";
// CSS
// Services
import { sendTicketAnswerService } from "../../../../../../Services/Profile/post/sendTicketAnswerService";
// Services
// Modules
import Swal from "sweetalert2";
import Spinner from "../../../../../../Utils/Spinner/Spinner";
import { toast } from "react-toastify";
// Modules

type DataAndInputContainerProps = {
  userToken: string;
  ticketId: string;
  setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
};

const DataAndInputContainer: React.FunctionComponent<
  DataAndInputContainerProps
> = ({ ticketId, userToken, setTrigger }) => {
  const [inputValue, setInputValue] = useState<string>("");
  //
  const [isPending, setIsPending] = useState<boolean>(false);
  //
  const [formFiles, setFormFiles] = useState<
    { name: number; value: string | any }[]
  >([]);
  return (
    <div className="px-4 flex flex-col items-center w-full ">
      <textarea
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
          setInputValue(e.target.value);
        }}
        value={inputValue}
        placeholder="پاسخ خود را وارد کنید ...."
        className="mt-8 rounded-xl p-2"
      />
      {/* {files.map((item) => (
          <input
            key={item.name}
            value={item.value}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {

            }}
          />
        ))} */}

      {formFiles.map((item, index) => (
        <div
          key={item.name}
          className="flex flex-row items-center justify-between mt-4"
        >
          <input
            type="file"
            accept="image/png, image/gif, image/jpeg, application/pdf"
            name={Math.random() * 120000 + ""}
            multiple={false}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const copyOfFormFiles = [...formFiles];
              const selectedItemIndex = formFiles.findIndex(
                (_item) => _item.name === item.name
              );
              console.log(selectedItemIndex);
              if (!e.target.files) return;
              copyOfFormFiles[selectedItemIndex].value = e.target.files[0];
              setFormFiles(copyOfFormFiles);
            }}
          />
          <span
            onClick={() => {
              const copyOfFormFiles = [...formFiles];
              const selectedItemIndex = formFiles.findIndex(
                (item) => item.name === index
              );
              copyOfFormFiles.splice(selectedItemIndex, 1);
              setFormFiles(copyOfFormFiles);
            }}
            style={{
              cursor: "pointer",
              paddingLeft: "0.5rem",
              paddingRight: "0.5rem",
              display: "block",
              background: "#dc3545",
              borderRadius: "4px",
              color: "#fff",
              marginTop: "4px",
              marginBottom: "4px",
            }}
          >
            حذف فایل
          </span>
        </div>
      ))}
      <button
        type="submit"
        className={`${styles.addFileBtn} w-full py-2 rounded-lg`}
        style={{
          marginTop: "1rem",
          marginBottom: "1rem",
        }}
        onClick={() => {
          setFormFiles((prevState) => [
            ...prevState,
            {
              name: Math.random() * 120000,
              value: "",
            },
          ]);

          return;
        }}
      >
        افزودن فایل
      </button>
      <button
        type="submit"
        color="success"
        className={`${styles.submitBtn} text-white py-2 mt-4 rounded-lg flex justify-center items-center`}
        onClick={() => {
          if (isPending) return;
          setIsPending(true);
          sendTicketAnswerService(
            userToken,
            formFiles.filter((item) => item.value),
            inputValue,
            String(ticketId)
          )
            .then(({ status }) => {
              console.log(status);
              setIsPending(false);

              if (status === 200) {
                Swal.fire({
                  icon: "success",
                  title: "تیکت با موفقیت ارسال شد",
                })
                  .then(() => {
                    setFormFiles([]);
                    setInputValue("");
                  })
                  .then(() => {
                    setTrigger((prevState) => !prevState);
                  })
                  .catch((err) => {
                    console.log(err);
                    toast(
                      err.response.data.message
                        ? err.response.data.message
                        : err.message
                    );
                  });
                return;
              } else {
                Swal.fire({
                  icon: "error",
                  title: "مشکلی در ارسال تیکت پیش آمده",
                  text: "فایل خالی / فرمت نادرست به سرور ارسال نمی شود",
                })
                  .then(() => {
                    setFormFiles([]);
                    setInputValue("");
                  })
                  .then(() => {
                    window.location.reload();
                  });
                return;
              }
            })
            .catch((err) => {
              console.log(err);
              Swal.fire({
                icon: "error",
                title: err.response.data.message
                  ? err.response.data.message
                  : err.message,
              });
              setIsPending(false);
            });
        }}
      >
        {isPending ? (
          <>
            <Spinner />
          </>
        ) : (
          <>ارسال پیام</>
        )}
      </button>
    </div>
  );
};

export default DataAndInputContainer;
